const lootOptions = {
    GOOD: 'good',
    BAD_TREE_LEFT: 'bad-tree-left',
    BAD_TREE_RIGHT: 'bad-tree-right',
    BAD_ROADBLOCK: 'bad-roadblock',
    BAD_ICE: 'bad-ice',
    BAD_SLED: 'bad-sled',
    BAD_LOG: 'bad-log',
    // BAD_SNOWFLAKE: 'bad-snowflake',
    BAD_ICEBERG: 'bad-iceberg',
    PROTECTION_1: 'protection-1',
    PROTECTION_2: 'protection-2',
    PROTECTION_3: 'protection-3'
};

export const lootOptionsArray = Array.from(Object.keys(lootOptions));

export const lootOptionsWeights = [
    16, // good
    2, // bad-tree-left
    2, // bad-tree-right
    2, // bad-roadblock
    2, // bad-hole
    2, // bad-police
    2, // bad-hotdog
    2, // bad-sewerage
    2, // bad-log
    2, // bad-iceberg
    2, // protection-1
    2, // protection-1
    2 // protection-3
];

export default lootOptions;
